import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
// import Dinamica from '../views/Dinamica.vue'
// import Resultado from '../views/Resultado.vue'
// import MiCuenta from '../views/MiCuenta.vue'
// import Participaciones from '../views/Participaciones.vue'
import Aviso from '../views/Aviso.vue'
import LoginReportes from '../views/LoginReportes.vue'


import { auth } from '../firebase'
import { nextTick } from 'vue';


Vue.use(VueRouter)

const routes = [
    // {
    //     path: '/',
    //     name: 'Dashboard',
    //     component: Dashboard,
    //     meta: {
    //         requiresAuth: true
    //     }
    // },
    // {
    //     path: '/',
    //     name: 'Teaser',
    //     component: () =>
    //         import ( /* webpackChunkName: "login" */ '../views/Teaser.vue')
    // },
    {
        path: '/',
        name: 'Login',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/Login.vue')
    },

    // // // // // // // // // // {
    // // // // // // // // // //     path: "/sorteo2",
    // // // // // // // // // //     name: "Sorteo",
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ "../views/Sorteo.vue"),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuth: false,
    // // // // // // // // // //     },
    // // // // // // // // // // },
    // // // // // // // // // // {
    // // // // // // // // // //     path: "/sorteo",
    // // // // // // // // // //     name: "Sorteo2",
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ "../views/Sorteo2.vue"),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuth: false,
    // // // // // // // // // //     },
    // // // // // // // // // // },
    {
        path: '/torneo',
        name: 'Torneo',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/Torneo.vue')
    },
    {
        path: '/faqs',
        name: 'Faqs',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/Faqs.vue')
    },
    // {
    //     path: '/verificacion/:id/:codigo',
    //     name: 'Verificacion',
    //     component: () =>
    //         import ( /* webpackChunkName: "login" */ '../views/Verificacion.vue')
    // },
    // {
    //     path: '/ganadores',
    //     name: 'Ganadores',
    //     component: () =>
    //         import ( /* webpackChunkName: "login" */ '../views/Ganadores.vue')
    // },
    {
        path: '/administrador',
        name: 'Administrador',
        component: LoginReportes,
    },
    {
        path: '/administrador/dashboard',
        name: 'Informe',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/ReportesInforme.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrador/registro-invitado',
        name: 'RegistroInvitadoAdmin',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/RegistroInvitadoAdmin.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrador/completar-registro/:id',
        name: 'CompletarRegistroAdmin',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/CompletarRegistroAdmin.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrador/edicion-registro/:id',
        name: 'EdicionRegistroAdmin',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/EdicionRegistroAdmin.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/administrador/edicion-invitados/:id',
        name: 'EdicionRegistroAdmin',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/EdicionInvitadosAdmin.vue'),
        meta: {
            requiresAuth: true
        }
    },
    // // // // // // // // // // {
    // // // // // // // // // //     path: '/lector',
    // // // // // // // // // //     name: 'LoginLector',
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ '../views/LoginLector.vue'),
    // // // // // // // // // // },
    // // // // // // // // // // {
    // // // // // // // // // //     path: '/lector/dashboard',
    // // // // // // // // // //     name: 'DashboardLector',
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ '../views/DashboardLector.vue'),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuthAdmin: true
    // // // // // // // // // //     }
    // // // // // // // // // // },
    // // // // // // // // // // {
    // // // // // // // // // //     path: '/lector/dashboard/patrocinadores',
    // // // // // // // // // //     name: 'DashboardLectorPatrocinadores',
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ '../views/DashboardLectorPatrocinadores.vue'),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuthAdmin: true
    // // // // // // // // // //     }
    // // // // // // // // // // },
    // // // // // // // // // // {
    // // // // // // // // // //     path: '/lector/scan',
    // // // // // // // // // //     name: 'ScanLector',
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ '../views/ReportesLector.vue'),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuthAdmin: true
    // // // // // // // // // //     }
    // // // // // // // // // // },
    // // // // // // // // // // {
    // // // // // // // // // //     path: '/lector/email',
    // // // // // // // // // //     name: 'EmailLector',
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ '../views/ReportesLectorEmail.vue'),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuthAdmin: true
    // // // // // // // // // //     }
    // // // // // // // // // // },
    // // // // // // // // // // {
    // // // // // // // // // //     path: '/lector/codigo',
    // // // // // // // // // //     name: 'EmailLectorCodigo',
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ '../views/ReportesLectorCodigo.vue'),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuthAdmin: true
    // // // // // // // // // //     }
    // // // // // // // // // // },
    // // // // // // // // // // {
    // // // // // // // // // //     path: '/lector/patrocinadores/scan',
    // // // // // // // // // //     name: 'ScanLector',
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ '../views/ReportesLectorPatrocinadores.vue'),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuthAdmin: true
    // // // // // // // // // //     }
    // // // // // // // // // // },
    // // // // // // // // // // {
    // // // // // // // // // //     path: '/lector/patrocinadores/email',
    // // // // // // // // // //     name: 'EmailLector',
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ '../views/ReportesLectorEmailPatrocinadores.vue'),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuthAdmin: true
    // // // // // // // // // //     }
    // // // // // // // // // // },
    // // // // // // // // // // {
    // // // // // // // // // //     path: '/lector/patrocinadores/codigo',
    // // // // // // // // // //     name: 'EmailLectorCodigo',
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ '../views/ReportesLectorCodigoPatrocinadores.vue'),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuthAdmin: true
    // // // // // // // // // //     }
    // // // // // // // // // // },
    // // // // // // // // // // {
    // // // // // // // // // //     path: '/lector/email/:email',
    // // // // // // // // // //     name: 'EmailLector',
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ '../views/ReportesLectorEmail.vue'),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuthAdmin: true
    // // // // // // // // // //     }
    // // // // // // // // // // },
    // // // // // // // // // // {
    // // // // // // // // // //     path: '/lector/busqueda',
    // // // // // // // // // //     name: 'BusquedaLector',
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ '../views/ReportesLectorBusqueda.vue'),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuthAdmin: true
    // // // // // // // // // //     }
    // // // // // // // // // // },
    // // // // // // // // // // {
    // // // // // // // // // //     path: '/lector/registro',
    // // // // // // // // // //     name: 'RegistroLector',
    // // // // // // // // // //     component: () =>
    // // // // // // // // // //         import ( /* webpackChunkName: "login" */ '../views/RegistroLector.vue'),
    // // // // // // // // // //     meta: {
    // // // // // // // // // //         requiresAuthAdmin: true
    // // // // // // // // // //     }
    // // // // // // // // // // },
    {
        path: '/aviso-de-privacidad',
        name: 'aviso',
        component: Aviso
    },
    {
        path: '/:id',
        name: 'Login',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/Login.vue')
    },

]




const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return new Promise((resolve) => {
                nextTick(() => {
                    // Espera 3 segundos antes de realizar el scroll
                    setTimeout(() => {
                        // Asegura que el elemento existe
                        if (document.querySelector(to.hash)) {
                            resolve({
                                el: to.hash,
                                behavior: 'smooth' // Desplazamiento suave
                            });
                        } else {
                            // Si el hash no se encuentra, hacer scroll al top
                            resolve({ x: 0, y: 0 });
                        }
                    }, 1500); // Espera 3 segundos
                });
            });
        }
        // Si no hay hash, hace scroll al top
        return { x: 0, y: 0 };
    },
    base: process.env.BASE_URL,
    routes
});



// navigation guard to check for logged in users
router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
    const requiresAuthAdmin = to.matched.some(x => x.meta.requiresAuthAdmin)

    const requiresNoTicket = to.matched.some(x => x.meta.requiresNoTicket)
    const requiresTicket = to.matched.some(x => x.meta.requiresTicket)

    let user;

    if (requiresAuth) {
        user = localStorage.getItem("user_copaprosa2021");
        user = JSON.parse(user);
        console.log(user)
    } else if (requiresAuthAdmin) {
        user = localStorage.getItem("user_copaprosa2021_lector");
        user = JSON.parse(user);
        console.log(user)
    }



    if (requiresAuth === true && user == null) {
        next('/administrador')
    } else if (requiresAuthAdmin === true && user == null) {
        next('/lector')
    } else {

        // if (user != null && requiresAuth == true) {
        //     next('/administrador/dashboard')
        // } else if (user != null && requiresAuthAdmin == true) {
        //     next('/lector/scan')
        // }


        next()
    }
})

export default router